import { Component } from '@theme/component';

class TextExpandComponent extends Component {
  requiredRefs = ['body', 'btn'];

  #expanded = false;

  connectedCallback() {
    super.connectedCallback();
    this.refs.btn.addEventListener('click', this.toggle.bind(this));
    
    // Check truncation on mount
    this.checkTruncation();
    
    // Check truncation when size changes
    this.resizeObserver = new ResizeObserver(() => {
      this.checkTruncation();
    });
    this.resizeObserver.observe(this);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  checkTruncation() {
    if (window.innerWidth >= 992) {
      this.refs.btn.classList.add('hidden');
      return;
    }

    if (this.#expanded) {
      this.refs.btn.classList.remove('hidden');
      return;
    }

    // Force clamp styles to measure scrollHeight vs clientHeight
    const lineClamp = this.getAttribute('data-line-clamp') || '2';
    this.refs.body.style.display = '-webkit-box';
    this.refs.body.style.webkitBoxOrient = 'vertical';
    this.refs.body.style.webkitLineClamp = lineClamp;
    this.refs.body.style.overflow = 'hidden';

    const hasOverflow = this.refs.body.scrollHeight > this.refs.body.clientHeight;

    this.refs.body.style.removeProperty('display');
    this.refs.body.style.removeProperty('webkit-box-orient');
    this.refs.body.style.removeProperty('webkit-line-clamp');
    this.refs.body.style.removeProperty('overflow');

    if (hasOverflow) {
      this.refs.btn.classList.remove('hidden');
    } else {
      this.refs.btn.classList.add('hidden');
    }
  }

  toggle() {
    this.#expanded = !this.#expanded;
    if (this.#expanded) {
      this.dataset.expanded = 'true';
      this.refs.btn.textContent = this.refs.btn.getAttribute('data-view-less');
    } else {
      this.dataset.expanded = 'false';
      this.refs.btn.textContent = this.refs.btn.getAttribute('data-view-more');
    }
    this.checkTruncation();
  }
}

if (!customElements.get('text-expand-component')) {
  customElements.define('text-expand-component', TextExpandComponent);
}
